import $ from "jquery"

export function favoriteBtn() {

    //Set Message Box
    (function () {
        const element = document.createElement('div');

        element.classList.add('favoriteMessage');
        element.id = 'favoriteMessage';

        document.body.appendChild(element);
    }())

    const messageBox = document.getElementById('favoriteMessage')



    const btns = document.getElementsByClassName('favoriteBtn');

    const addFavoriteClass = 'addFavorite';
    const onFavoriteClass = 'onFavorite';

    for (let i = 0, len = btns.length; i < len; i++) {
        btns[i].addEventListener('click', () => {
            let tgt = btns[i];
            let messageText;
            let pid = tgt.value;
            let label = btns[i].getElementsByClassName('label')[0];
            let btnText;

            //Button Function
            if (tgt.classList.contains(addFavoriteClass)) {
                tgt.classList.remove(addFavoriteClass);
                tgt.classList.add(onFavoriteClass);

                messageText = 'お気に入りに<strong>登録</strong>しました。';
                btnText = 'お気に入り登録済み';

                $.ajax({
                    url:"https://www.fukujinsupport.com/favorite_db.php",
                    type:"POST",
                    data: "pid="+pid+"&type=1",
                    timeout: 10000,
                    success: function(result, textStatus, xhr) { // eslint-disable-line
                        console.log(this.response);
                    },
                    error: function(xhr, textStatus, error) { // eslint-disable-line
                        alert(error);
                    }
                });
            } else if (tgt.classList.contains(onFavoriteClass)) {
                tgt.classList.remove(onFavoriteClass);
                tgt.classList.add(addFavoriteClass);

                messageText = 'お気に入りを<strong>解除</strong>しました。';
                btnText = 'お気に入りに登録する';

                $.ajax({
                    url:"https://www.fukujinsupport.com/favorite_db.php",
                    type:"POST",
                    data: "pid="+pid+"&type=2",
                    timeout: 10000,
                    success: function(result, textStatus, xhr) { // eslint-disable-line
                        console.log(this.response);
                    },
                    error: function(xhr, textStatus, error) { // eslint-disable-line
                        alert(error);
                    }
                });
            }
            //Button Text Set
            if (btns[i].getElementsByClassName('label')[0]){
                label.innerText = btnText;
            }


            //Set Message
            if ( !document.getElementById('message' + i) ){
                let message = document.createElement('div');

                message.id = 'message' + i;
                message.className = 'favoriteMessage_item';
                message.innerHTML = messageText;

                messageBox.appendChild(message);
            }
            else {
                document.getElementById('message' + i).innerHTML = messageText;
            }


            //Display Message
            (function () {
                let messageElement = document.getElementById('message' + i);
                const displayTime = 3000;

                clearTimeout();

                setTimeout(function () {
                    messageElement.classList.add('onFade')
                })

                setTimeout(function () {
                    messageElement.classList.remove('onFade')
                }, displayTime - 300)

                setTimeout(function () {
                    messageElement.remove();
                }, displayTime)
            }())

        })
    }


}